import React from 'react'

class LandownerResult extends React.Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.property.gid !== this.props.property.gid) {
      if (this.state !== null && this.state.poly !== null) {
        this.state.poly.setMap(null)
      }
      this.setState({
        clicked: false,
        poly: null
      })
    }
  }

  handleClick(e) {
    e.preventDefault()
    const { center, gid } = this.props.property
    this.props.handleParcelClick(center, gid)
  }

  render() {
    const parcelInfo = this.props.property,
      clicked = this.props.activeId === this.props.property.gid,
      entryColor = clicked ? 'rgb(88, 149, 0)' : 'rgb(0, 0, 0)'

    return (
      <div style={{
        color: '#959595',
        border: clicked ? '2px solid white' : 'none',
        borderBottom: clicked ? '2px solid white' : '3px solid black',
        marginTop: '5px',
        width: '100%',
        boxSizing: 'border-box',
        padding: '2px'
      }}
        onClick={this.handleClick}>
        <p
          className='places-dialog__text__name'
          style={{
            cursor: 'pointer',
            color: '#959595'
          }}>
          {parcelInfo.ownerName}
        </p>
        <div style={{
          display: 'flex',
          padding: '1%',
          width: '98%',
          marginBottom: '3px',
        }}>
          <div>
            {
              parcelInfo.ownerAddress.length > 1 ?
                <p
                  className='places-dialog__text__address'
                  style={{ color: '#959595' }}
                >
                  {`${parcelInfo.ownerAddress},`}
                </p> : null
            }
            <p
              className='places-dialog__text__address'
              style={{ color: '#959595' }}
            >
              {`${parcelInfo.ownerCity}, ${parcelInfo.ownerState} ${parcelInfo.ownerZipCode}`}
            </p>
            <p
              className='places-dialog__text__address'
              style={{ fontWeight: 'bold', color: 'white' }}
            >
              {parcelInfo.distance}
            </p>
          </div>
        </div>
        <div style={{
          color: 'black',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '1%',
          width: '98%',
          marginTop: '3px'
        }}>
        </div>
      </div>
    )
  }
}

export default LandownerResult